import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { AccountAttributesEnum } from '../../enums';
import { CommonUtilService } from '../../services/CommonUtil.service';
import {  MAT_DIALOG_DATA,  MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-request-research-modal',
    templateUrl: './request-research-modal.component.html',
    styleUrls: ['./request-research-modal.component.scss'],
    standalone: false
})
export class RequestResearchModalComponent implements OnInit {
    initialData;
    requestResearchForm: FormGroup;
    maxLength = 60;
    accountAttributesEnum = AccountAttributesEnum;

    constructor(
        private formBuilder: FormBuilder,
        private commonUtilService: CommonUtilService,
        private readonly matDialogRef: MatDialogRef<RequestResearchModalComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: any,
    ) { }

    ngOnInit(): void {
        this.initialData = this.data as any;
        const inputValidators: ValidatorFn[] = [
            this.initialData.mandatoryInput ? Validators.required : null,
            ...(this.initialData.inputValidators ? this.initialData.inputValidators : []),
        ].filter(Boolean);

        this.requestResearchForm = this.formBuilder.group({
            inputValue: [this.initialData.inputValue, inputValidators],
            requestName: [""]
        });
    }

    submitPrompt() {
        if (this.requestResearchForm.valid) {
            const value: string = this.requestResearchForm.get('inputValue').value;
            const requestName: string = this.requestResearchForm.get('requestName').value;
            const inputValue = value;
            this.closeModal({
                success: true,
                inputValue,
                requestName
            });
            return;
        }
    }

    closeModal(res?: any): void {
        this.matDialogRef.close(res);
    }

}
